import React, { useImperativeHandle, useState, useRef } from "react";
import EmployeeResignDialog from "@icoach/employees/dialog/EmloyeeResignDialog";
import { isFunction, isEqual } from "@util/utils";

const EMPLOYEE_RESIGN_DIALOG = "EmployeeResign";

const EmployeeDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState({});
	const refreshRef = useRef(null);

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) refreshRef.current(...arg);
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				openEmployeeResignDialog: (targetData, _refreshFn = () => {}) => {
					setSourceData(targetData);
					setOpenDialog(EMPLOYEE_RESIGN_DIALOG);
					refreshRef.current = _refreshFn;
				},
				closeDialog: () => handleDialogClose(),
			};
		},
		// eslint-disable-next-line
		[]
	);

	const handleDialogClose = () => {
		setOpenDialog(null);
		setSourceData(null);
		refreshRef.current = null;
	};

	if (!openDialog) return null;

	return (
		<React.Fragment>
			<EmployeeResignDialog open={isEqual(openDialog, EMPLOYEE_RESIGN_DIALOG)} onClose={handleDialogClose} sourceData={sourceData} refresh={doRefresh} />
		</React.Fragment>
	);
});

export default EmployeeDialogBox;
